module.exports = __webpack_public_path__ + "static/sacrificial-bow-dfe5d724909137bb696a98754e288959.png";